import { makeStyles } from '@material-ui/core/styles';

export const useFormBaseStyles = makeStyles(() => ({
  container: {
    borderTop: (props) =>
      props.issueForm ? null : props.mobile ? null : '1px solid #64148E',
    backgroundColor: (props) =>
      props.issueForm ? null : props.mobile ? null : '#F1F1F1',
    display: 'flex',
    flexDirection: 'column',
    width: (props) => (props.mobile ? '95%' : '100%'),
    padding: (props) => (props.mobile ? '' : '30px 70px'),
    margin: '20px auto',
  },
  title: {
    color: '#464646',
    fontSize: 16,
    textAlign: (props) => (props.mobile ? 'center' : null),
  },
  message: {
    marginBottom: (props) => (props.mobile ? '30px' : '20px'),
  },
}));
